import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { SpaceResponse, SpacesResponse } from "./SpacesTypes";
const ENDPOINT_SPACES = "spaces";

const getSpaces = (token: string) => {
  const spacesResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_SPACES as string,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as SpacesResponse)
  return spacesResult;
};

const getSpaceById = (token: string, idSpace: number) => {
  const endpoint = `${ENDPOINT_SPACES}/${idSpace}`;

  const spacesResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    endpoint,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as SpaceResponse);
  return spacesResult;
};

export { getSpaces, getSpaceById };
